import { Button } from "@/components/ui/button";
import { FileTextIcon } from "@radix-ui/react-icons";

interface BtnDownloadProps {
    onClick?: () => void;
}


export default function BtnDownload({ onClick }: BtnDownloadProps) {
    return (
        <Button variant="ghost" size="icon" asChild onClick={onClick}>
            <a href="/david_andersson_resume.pdf" target="_blank" rel="noreferrer" aria-label="Download Resume" className="flex items-center justify-center">
                <FileTextIcon />
            </a>
        </Button>
    );
}